/* eslint-disable import/no-extraneous-dependencies */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import SuiVue from 'semantic-ui-vue';
import VeeValidate from 'vee-validate';
import VueI18n from 'vue-i18n';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import App from '@/App';
import router from '@/router';
import store from '@/store';

Vue.config.productionTip = false;
Vue.use(SuiVue);
Vue.use(VeeValidate);
Vue.use(VueI18n);
Vue.use(VuejsDialog);
Vue.use(require('vue-moment'));

const i18n = new VueI18n({
  locale: store.getters.language,
  messages: {
    en: {
      studentPortal: 'Student Portal',
      welcomeTitle: 'Welcome',
      welcomeText:
        'Hi There! Please select your name on the next page. This will allow you to choose team mates that you feel you work best with. Click on the arrow to continue.',
      invalidTestCode: 'No valid test code has been provided',
      testAlreadyCompleted: 'This test has already been completed',
      testExpired:
        'The duration for this test has expired. If this is not correct please ask your teacher to extend the time for this test.',
      studentSelectionConfirmationText:
        'You have selected "{firstName} {lastName}". Are you sure you want to continue?',
      studentSelectionConfirmationContinueButton: 'Continue',
      studentSelectionConfirmationCancelButton: 'No, go back',
      studentSelectionTitle: 'Select your name and complete the form',
      studentSelectionButton: 'select',
      studentSelectionColumnLastName: 'Last name',
      studentSelectionColumnFirstName: 'First name',
      choiceSelectionTitle:
        'Please complete the form below {name} and click on "submit answers" when you are finished',
      choiceSelectionBackButton: 'Back to student selection',
      choiceSelectionSubmitButton: 'Submit answers',
      choiceSelectionErrorMessageAnswer: 'Please provide an answer',
      choiceSelectionErrorMessageChoice:
        'Please make a choice for each student in the list',
      choiceSelectionColumnName: 'Name',
      choiceSelectionColumnLike: 'Like to work with most',
      choiceSelectionColumnNeutral: "Don't mind",
      choiceSelectionColumnReject: 'Like to work with least',
      choiceSelectionNoStudents: 'No students found',
      thankYouTitle: 'Thank you for your time {name}',
      thankYouText:
        'Your nominations have been submitted, you can now close this browser window.',
    },
    ga: {
      studentPortal: 'Tairseach gan fada',
      welcomeTitle: 'Fáilte romhat',
      welcomeText:
        "Haigh, Roghnaigh d'ainm ar an gcéad leathanach eile le do thoil. Ligfidh sé seo duit na daoine is fearr a n-oibríonn tú leo a roghnú chun obair ar do fhoireann.",
      invalidTestCode: 'Níor cuireadh aon chód tástála bailí ar fáil',
      testAlreadyCompleted: 'Tá an tástáil seo curtha i gcrích cheana féin',
      testExpired:
        'Tá fad na tástála imithe in éag. Mura bhfuil sé seo ceart, iarr ar do mhúinteoir síneadh ama a chur leis seo',
      studentSelectionConfirmationText:
        'Roghnaigh tú "{firstName} {lastName}". An bfuil tú cinnte go bhfuil sé seo ceart?',
      studentSelectionConfirmationContinueButton: 'Tá, lean ar aghaid',
      studentSelectionConfirmationCancelButton: 'Níl, Teig ar ais',
      studentSelectionTitle: "Roghnaigh d'ainm agus líon isteach an fhoirm",
      studentSelectionButton: 'Roghnaigh',
      studentSelectionColumnLastName: 'Sloinne',
      studentSelectionColumnFirstName: 'Ainm',
      choiceSelectionTitle:
        'Críochnaigh an fhoirm thíos le do thoil agus cliceáil ar "cuir isteach do fhreagraí" nuair atá tú críochnaithe',
      choiceSelectionBackButton: 'Téigh ar ais go dtí scoláire a roghnú',
      choiceSelectionSubmitButton: 'Cuir isteach do fhreagraí',
      choiceSelectionErrorMessageAnswer: 'Tabhair freagra le do thoil',
      choiceSelectionErrorMessageChoice:
        'Déan rogha do gach dalta ar an liosta',
      choiceSelectionColumnName: 'Ainm',
      choiceSelectionColumnLike: "B'fhearr liom  obair leis an duine seo",
      choiceSelectionColumnNeutral:
        'Is cuma liom a bheith ag obair leis an duine seo',
      choiceSelectionColumnReject:
        'An duine is lú gur mhaith liom a bheith ag obair le',
      choiceSelectionNoStudents: 'Níl aon scoláirí ar fáil',
      thankYouTitle: 'Go raibh maith agat as ucht do chuid ama',
      thankYouText:
        'Tá do chuid ainmnúicháin curtha isteach, is féidir an fhuinneog seo a dhúnadh anois',
    },
  },
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js